export const BASE_URL = 'https://frontend-take-home-service.fetch.com'
export const PAGE_SIZE = '8'

export const DEFAULT_SORT = 'breed:asc'

export const SORT_BY_OPTIONS = {
    'breed': 'breed',
    'age': 'age',
    'name': 'name'
}
export const SORTING_ORDER_OPTIONS = {
    'asc': 'ascending',
    'desc': 'descending'
}